// removed by extract-text-webpack-plugin
module.exports = {"Content":"layout__Content__1x5Dd"};


//////////////////
// WEBPACK FOOTER
// ./src/hoc/Layout/layout.css
// module id = 93
// module chunks = 3